"use-strict";

import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";
import Photoswipe from "./photoswipe.esm.min.js";
// js gallery
class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || "no_zoom";
    this.zoomOption = this.dataset.zoomOption || "external";
    this.lightbox = null;
    this.drift = null;
    this.lightboxBound = false;
    this.onResize = this.responsive.bind(this);
    this.init();
  }
  init() {
    if (this.type === "no_zoom") return;
    window.addEventListener("resize", this.onResize);
    window.addEventListener("load", this.onResize);
    // Delegated click handler: bound once, works for every image inside this
    // element, including galleries re-rendered after page load (colour change).
    this.initLightBox();
    // The "load" event has already fired if this element was created after page load.
    if (document.readyState === "complete") {
      setTimeout(this.onResize, 0);
    }
  }
  initLightBox() {
    if (this.lightboxBound) return;
    this.lightboxBound = true;
    this.addEventListener("click", (e) => {
      const link = e.target.closest("a.media-gallery__image");
      if (!link || !this.contains(link)) return;
      // Never navigate to the raw image file.
      e.preventDefault();
      // Hover-zoom modes on desktop do not use the popup.
      if (window.innerWidth >= 768 && this.type !== "open_lightbox") return;
      this.openLightBox(link);
    });
  }
  getLightBox() {
    if (this.lightbox) return this.lightbox;
    const lightbox = new PhotoSwipeLightbox({
      pswpModule: () => Photoswipe,
      counter: false,
      zoom: false,
      preloader: false,
      arrowPrev: false,
      arrowNext: false,
      close: false,
      loop: false,
      bgOpacity: 1,
    });
    lightbox.on("uiRegister", () => {
      const { pswp } = lightbox;
      pswp?.ui.registerElement({
        name: "bls--close",
        isButton: true,
        tagName: "button",
        html: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition"><use href="#icon-close"></use></svg>',
        onClick: () => {
          pswp.close();
        },
      });
      pswp?.ui.registerElement({
        name: "bottomBar",
        className: "pswp__bottom-bar",
        appendTo: "wrapper",
        onInit: (el, pswp) => {
          let next, prev, counter;
          next = document.createElement("button");
          next.setAttribute("type", "button");
          next.className = "pswp__button pswp__button-next";
          next.innerHTML = `<svg width="6" height="11" fill="none">
              <use href="#icon-next"></use>
            </svg>`;
          next.onclick = () => {
            pswp.next();
          };
          el.appendChild(next);

          counter = document.createElement("span");
          counter.className = "pswp__counter";
          pswp.on("change", () => {
            counter.innerText =
              pswp.currIndex +
              1 +
              pswp.options.indexIndicatorSep +
              pswp.getNumItems();
          });
          el.appendChild(counter);

          prev = document.createElement("button");
          prev.setAttribute("type", "button");
          prev.className = "pswp__button pswp__button-prev";
          prev.innerHTML = `<svg width="6" height="11" fill="none">
              <use href="#icon-back"></use>
            </svg>`;
          prev.onclick = () => {
            pswp.prev();
          };
          el.appendChild(prev);
        },
      });
    });
    lightbox.init();
    this.lightbox = lightbox;
    return lightbox;
  }
  openLightBox(link) {
    const links = Array.from(this.querySelectorAll("a.media-gallery__image"));
    const items = links.map((a) => {
      const img = a.querySelector("img");
      return {
        src: a.href,
        width: parseInt(a.dataset.pswpWidth, 10) || 0,
        height: parseInt(a.dataset.pswpHeight, 10) || 0,
        alt: img ? img.alt : "",
      };
    });
    const index = Math.max(0, links.indexOf(link));
    const lightbox = this.getLightBox();
    lightbox.options.dataSource = items;
    lightbox.loadAndOpen(index, items);
  }
  initDrift() {
    if (this.drift !== null) return;
    if (typeof Drift === "undefined") return;
    var allTriggers = this.querySelectorAll(".drift-trigger");
    const container = this.closest(".sec__featured-product");
    const paneContainer = container
      ? container.querySelector(".zoom-external-area")
      : null;
    if (allTriggers.length != 0) {
      allTriggers.forEach((trigger) => {
        const inlineContainer = trigger.closest("[data-pane-container]");
        const zoomOption = this.zoomOption;
        if (zoomOption === "inner-2") {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption === "inner-2",
            zoomFactor: 2,
            containInline: paneContainer,
            paneContainer: inlineContainer,
            hoverBoundingBox: zoomOption === "external",
            onShow: function () {
              inlineContainer.classList.add("relative");
            },
            onHide: function () {
              inlineContainer.classList.remove("relative");
            },
          });
        } else {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption,
            zoomFactor: 5,
            containInline: paneContainer,
            paneContainer:
              zoomOption === "external" ? paneContainer : inlineContainer,
            hoverBoundingBox: zoomOption === "external",
            onShow: function () {
              inlineContainer.classList.add("relative");
            },
            onHide: function () {
              inlineContainer.classList.remove("relative");
            },
          });
        }
      });
    }
  }
  responsive() {
    if (window.innerWidth >= 768) {
      if (this.type !== "open_lightbox") {
        this.initDrift();
      }
    } else if (this.drift !== null) {
      this.drift.destroy();
      this.drift = null;
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper === "undefined") return;
    const thumbs = this.querySelector(".thumbnail-slide");
    if (thumbs && thumbs.swiper) {
      thumbs.swiper.update();
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("load", this.onResize);
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  }
}
customElements.define("zoom-action", ZoomAction);
